// 活動無開獎紀錄
import Image from 'next/image';

const CampaignEmptyRecord = ({ type }) => {
    return (
        <div
            className={`!block space-y-[38px] text-center ${
                type === 'list' ? 'mt-[38px]' : 'mt-[5px]'
            }`}
        >
            <div className="img-box w-[21px] h-[89px] mx-auto after:content-none">
                <Image
                    className="inline-block mx-auto"
                    width={21}
                    height={89}
                    src="/images/icon/icon_empty_record.svg"
                    alt="empty_record"
                />
            </div>
            <p className="text-btn3b text-[#fff]">尚無開獎紀錄</p>
        </div>
    );
};

export default CampaignEmptyRecord;
